import { getRequest } from '@helpers/api';

/**
 * Retrieves a list of countries
 */
export const getCountries = (limit?: number): Promise<unknown> =>
  getRequest('countries/country/', { limit });

/**
 * Fetches a currency for a given country
 */
export const getCurrency = (countryId: string): Promise<unknown> =>
  getRequest('countries/currency/', { country: countryId });

/**
 * Fetches the vat rate for a given country
 */
export const getVatRate = (countryId: string): Promise<unknown> =>
  getRequest(`countries/vatRate/${countryId}/`);
